import Swiper from "swiper";
import { Navigation } from "swiper/modules";

// Initialize Swiper
export function init() {
	document
		.querySelectorAll(
			".wp-block-gallery.is-style-carousel, .wp-block-gallery:has(.is-style-carousel)",
		)
		.forEach((block) => {
			function createSwiperWrapper() {
				if (!block.parentElement.classList.contains("swiper")) {
					const swiperWrapper = document.createElement("div");
					swiperWrapper.classList.add("swiper", "alignwide");

					block.parentNode.insertBefore(swiperWrapper, block);
					swiperWrapper.appendChild(block);

					return swiperWrapper;
				}
				return block.parentElement;
			}

			function addClasses() {
				const slides = block.querySelectorAll(".wp-block-image");

				block.classList.add("swiper-wrapper");
				slides.forEach((slide) => slide.classList.add("swiper-slide"));

				const swiperContainer = block.parentElement;

				// Add navigation buttons inside the swiper container
				if (!swiperContainer.querySelector(".swiper-navigation")) {
					const navigationContainer = document.createElement("div");
					navigationContainer.classList.add("swiper-navigation");

					const prevButton = document.createElement("div");
					const nextButton = document.createElement("div");
					prevButton.classList.add("swiper-button-prev");
					nextButton.classList.add("swiper-button-next");

					navigationContainer.appendChild(prevButton);
					navigationContainer.appendChild(nextButton);
					swiperContainer.appendChild(navigationContainer);
				}
			}

			let swiper = null;

			function evaluate() {
				if (!swiper) {
					const swiperContainer = createSwiperWrapper();
					addClasses();

					swiper = new Swiper(swiperContainer, {
						loop: false,
						spaceBetween: 20,
						slidesPerView: 1,

						modules: [Navigation],
						navigation: {
							nextEl: swiperContainer.querySelector(".swiper-button-next"),
							prevEl: swiperContainer.querySelector(".swiper-button-prev"),
						},
						cssMode: false,
						watchOverflow: true,
						normalizeSlideIndex: true,
					});
				}
			}

			if (document.readyState === "loading") {
				document.addEventListener("DOMContentLoaded", evaluate);
			} else {
				evaluate();
			}

			window.addEventListener("resize", evaluate);
		});
}
